import { useState } from "react";
import api, { formatErr } from "@/lib/api";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (e) { setErr(formatErr(e.response?.data?.detail) || "Something went wrong"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 vb-fade-in" data-testid="forgot-page">
      <form onSubmit={submit} className="w-full max-w-md vb-card p-8" data-testid="forgot-form">
        <Link to="/login" className="vb-link text-sm flex items-center gap-1 mb-3"><ArrowLeft size={14} /> Back to sign in</Link>
        <h2 className="vb-heading text-2xl mb-1" style={{ color: "var(--vb-text-2)" }}>Reset your password</h2>
        <p className="opacity-70 mb-5 text-sm">Enter the email or username on your Vanguard Beacon account. We'll send you a reset link.</p>

        {done ? (
          <div className="vb-pill ok mb-2 w-full" data-testid="forgot-done">
            ✓ If that account exists, a reset link has been sent. Check your inbox (or ask your admin to check the system logs).
          </div>
        ) : (
          <>
            {err && <div className="vb-pill err mb-3 w-full" data-testid="forgot-error">{err}</div>}
            <label className="block text-xs font-semibold mb-1.5 uppercase tracking-wider" style={{ color: "var(--vb-text-2)" }}>Email or username</label>
            <input data-testid="forgot-email" type="text" required value={email} onChange={(e) => setEmail(e.target.value)} className="vb-input mb-5" placeholder="you@company.com" autoComplete="username" />
            <button type="submit" className="vb-btn w-full" disabled={busy} data-testid="forgot-submit">
              {busy ? "Sending…" : "Send reset link"}
            </button>
          </>
        )}
      </form>
    </div>
  );
}
